import React from "react";
import CanvasMeter from 'canvas-meter';
import {
    Row, Col, Card, CardBody, Button, Table, Popover, PopoverHeader, PopoverBody
} from 'reactstrap';

import { getSpeedoSkin } from "../../../Credit-worthiness-dashboard/speedometerconfig";
import { NOTE, RUBIX_PAYMENT_RISK_SCORE, RUBIX_PAYMENT_RISK_SCORE_DESCRIPTION } from "../constants";
import classnames from 'classnames';
import { paymentRiskGradeData, getRiskObject } from './util'


const riskGradeTableView = paymentRiskGradeData.map(p => {
    return (
        <Row key={p.riskGrade} noGutters className={classnames('border-bottom mb-3 mb-sm-0')}>
            <Col xs="24" sm="3" className="p-1">{p.minScore}-{p.maxScore}</Col>
            <Col xs="24" sm="4" className="p-1">{p.grade}</Col>
            <Col xs="24" sm="11" className="p-1 text-truncate">{p.description}</Col>
            <Col xs="24" sm="4" className="p-1">{p.category}</Col>
        </Row>
    )
});

class PaymentRiskScoreMeter extends React.Component {

    state = { grade: "", description: "", category: "HIGH", popoverOpen: false }
    drawMeter = () => {
        const meterValues = { totalScore: this.props.paymentScore, highRiskValue: { min: 0, max: 50 }, lowRiskValue: { min: 70, max: 100 }, mediumRiskValue: { min: 50, max: 70 }, min: 0, max: 100 }
        const meter = new CanvasMeter(document.getElementById("risk-meter"));
        meter.draw(meterValues.totalScore, meterValues.min, meterValues.max, 45, 45);
        meter.setOptions(getSpeedoSkin(meterValues))
    }

    componentDidMount() {
        this.drawMeter();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.paymentScore !== this.props.paymentScore) {
            this.drawMeter();
            let riskMeterObject = getRiskObject(this.props.paymentScore)
            this.setState({ ...riskMeterObject });

        }
    }

    descriptionPopoverToggleGrade = () => {
        this.setState({ popoverOpen: !this.state.popoverOpen });
    }

    render() {
        return (<React.Fragment>
            <Card body className='mt-3 mb-3'>
                <div>
                    <h3 className='text-center'>
                        {RUBIX_PAYMENT_RISK_SCORE}
                    </h3>

                </div>
                <CardBody className="report-block-body">
                    <div className="speedometer-wrapper" style={{ textAlign: 'center' }}>
                        <canvas height="170" id="risk-meter"></canvas>
                    </div>
                    <div className="text-center title">
                        {this.state.grade}    &nbsp; &nbsp; ({this.state.description}) 
                        <Button size="sm" color="link" onClick={this.descriptionPopoverToggleGrade} id="riskGradePopOver">
                            <i className="icon-info"></i>
                        </Button>
                    </div>
                </CardBody>
                <Table style={{ width: "60%", marginLeft: "auto", marginRight: "auto" }} bordered >
                    <thead >
                        <tr>
                            <th className="cug-risk-table-th">No. of Members</th>
                            <th className="cug-risk-table-th">No. of Months Data</th>
                            <th className="cug-risk-table-th">No. of Tradelines</th>
                        </tr>
                    </thead>

                    <tbody >
                        <tr>
                            <td className="cug-risk-table-tr"> {this.props.noOfMembers} </td>
                            <td className="cug-risk-table-tr" > {this.props.noOfMonths} </td>
                            <td className="cug-risk-table-tr" > {this.props.noOfTradelines} </td>
                        </tr>
                    </tbody>

                </Table>

                <details>
                    <summary>
                        <i>Know more...</i>
                    </summary>
                    <p dangerouslySetInnerHTML={{ __html: RUBIX_PAYMENT_RISK_SCORE_DESCRIPTION }}></p>
                </details>

            </Card>

            <Popover placement="bottom" isOpen={this.state.popoverOpen} target="riskGradePopOver" toggle={this.descriptionPopoverToggleGrade}>
                <PopoverHeader>Risk Grades</PopoverHeader>
                <PopoverBody>
                    <Row noGutters className="mb-3 custom-table-header d-sm-flex align-items-center">
                        <Col xs="24" sm="3" className="custom-table-header-title p-1">Range</Col>
                        <Col xs="24" sm="4" className="custom-table-header-title p-1">Grades</Col>
                        <Col xs="24" sm="11" className="custom-table-header-title p-1">Grade Description</Col>
                        <Col xs="24" sm="4" className="custom-table-header-title p-1">Category</Col>
                    </Row>
                    {riskGradeTableView}
                </PopoverBody>
            </Popover>
        </React.Fragment>)
    }
}

export default PaymentRiskScoreMeter;











